import { createStore } from "vuex";
import employees from './_modules/employees';
import products from './_modules/products';
import categories from './_modules/categories';
import customers from './_modules/customers';
// import payment_methods from './_modules/payment_methods';
import outlets from './_modules/outlets';
// import units from './_modules/units';
import attributes from './_modules/attributes';
import attribute_lists from './_modules/attribute_lists';
import inventories from './_modules/inventories';
import attendances from './_modules/attendances';
import transactions from './_modules/transactions';
import pos_products from './_modules/pos_products';
import pos_services from './_modules/pos_services';
import pos_payments from './_modules/pos_payments';
import darkMode from './darkMode';

import bill_of_material_details from "./modules/bill_of_material_details";
import bill_of_materials from "./modules/bill_of_materials";
import cash_bank_accounts from "./modules/cash_bank_accounts";
import cash_bank_mutations from "./modules/cash_bank_mutations";
import cash_registers from "./modules/cash_registers";
import item_categories from "./modules/item_categories";
import items from "./modules/items";
import kitchen_divisions from "./modules/kitchen_divisions";
import marketings from "./modules/marketings";
import payment_methods from "./modules/payment_methods";
import purchase_order_details from "./modules/purchase_order_details";
import purchase_orders from "./modules/purchase_orders";
import sales_order_menus from "./modules/sales_order_menus";
import sales_orders from "./modules/sales_orders";
import settings from "./modules/settings";
import stock_movements from "./modules/stock_movements";
import stock_opname_details from "./modules/stock_opname_details";
import stock_opnames from "./modules/stock_opnames";
import tables from "./modules/tables";
import transaction_type from "./modules/transaction_type";
import units from "./modules/units";
import warehouses from "./modules/warehouses";
import users from "./modules/users";
import roles from './modules/roles';

import reports from "./modules/reports";
import petty_cash from "./modules/petty_cash";

import global_discounts from "./modules/global_discounts";

import permissions from "./modules/permissions";
import role_permissions from "./modules/role_permissions";
import detail_user from "./modules/detail_user";
import activity_logs from "./modules/activity_log";

import inbound_items_forms from "./modules/inbound_items_forms";
import inbound_items_form_details from "./modules/inbound_items_form_details";
import outbound_items_forms from "./modules/outbound_items_forms";
import outbound_items_form_details from "./modules/outbound_items_form_details";

const store = createStore({
    modules: {
        employees,
        products,
        categories,
        customers,
        // payment_methods,
        petty_cash,
        outlets,
        roles,
        // units,
        attributes,
        activity_logs,
        attribute_lists,
        inventories,
        detail_user,
        attendances,
        transactions,
        pos_products,
        pos_services,
        pos_payments,
        darkMode,
        bill_of_material_details,
        bill_of_materials,
        cash_bank_accounts,
        cash_bank_mutations,
        cash_registers,
        item_categories,
        items,
        kitchen_divisions,
        marketings,
        payment_methods,
        purchase_order_details,
        purchase_orders,
        sales_order_menus,
        sales_orders,
        settings,
        stock_movements,
        stock_opname_details,
        stock_opnames,
        tables,
        transaction_type,
        units,
        warehouses,
        users,

        reports,

        global_discounts,

        permissions,
        role_permissions,

        inbound_items_forms,
        inbound_items_form_details,
        outbound_items_forms,
        outbound_items_form_details,
    }
});

export default store;